import { Component, Input, OnInit } from '@angular/core'
import { of, Subscription } from 'rxjs'
import { delay, finalize } from 'rxjs/operators'
import { Application } from 'src/app/account/services/application.service'
import { UninstallDrsAgentIssue } from 'src/app/account/services/issue'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { ApiService } from 'src/app/services/api.service'
import { SyncPairIssueScopeDto } from 'src/app/services/dtos'
import { UiService } from 'src/app/services/ui.service'
import { handleArpioError } from 'src/utils/handle-error'
import { subscriptionActive } from 'src/utils/rxjs-utils'
import { ViewableIssue } from '../../issues-view/issues-view.component'

@Component({
  selector: 'uninstall-drs-agent-issue',
  templateUrl: './uninstall-drs-agent-issue.component.html',
  styleUrls: ['./uninstall-drs-agent-issue.component.scss'],
  standalone: false,
})
export class UninstallDrsAgentIssueComponent implements OnInit {
  @Input() issue: ViewableIssue = null
  @Input('sync-pair') syncPair: SyncPair = null
  @Input('application') application: Application = null

  private ackSubscription: Subscription = null

  constructor(
    public uiService: UiService,
    public apiService: ApiService
  ) {}

  ngOnInit(): void {}

  acknowledgeIssue() {
    this.ackSubscription = this.issue
      .deleter$()
      .pipe(finalize(() => (this.ackSubscription = null)))
      .subscribe(
        (_response) => {},
        (err) => {
          handleArpioError(window.location.href, this.apiService, this.uiService)(err)
        }
      )
  }

  private get typedIssue() {
    return this.issue.issue as UninstallDrsAgentIssue
  }

  get ec2InstanceId() {
    return this.typedIssue.ec2InstanceId
  }

  get sourceServerId() {
    return this.typedIssue.sourceServerId
  }

  get acknowledging() {
    return subscriptionActive(this.ackSubscription)
  }
}
